import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import MUILink from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from "@material-ui/core/Switch";
import { Link } from 'react-router-dom';
import { Divider } from '@material-ui/core';
import { Licences } from '../util/HardCodedLists';
import { ModelBundle } from '../types/List';

interface attPropTypes {
    bundle: ModelBundle;
    licence: string;
    open: boolean;
    handleClose: { (event: {}, reason: "backdropClick" | "escapeKeyDown"): void; (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void; };
    snackbar: any;
}

export default function BundleAttributionPopup(props: attPropTypes) {

    const attributionRef = React.createRef();

    const title = {
        "CC-BY 3.0": "You must include attribution",
        "mixed": "You must include attribution",
        "CC0 1.0": "Thanks for downloading!",
    }

    const licenceText = {
        "CC-BY 3.0": () => <>These models are published under a CC-BY license. That means they can be used in any project (personal or commercial) so long as the text and links below are included. <MUILink color="primary" href="https://creativecommons.org/licenses/by/3.0/" target="_blank">Learn more</MUILink></>,
        "mixed": () => <>These models are published under CC-BY or CC0 license. That means they can be used in any project (personal or commercial) so long as the text and links below are included. <MUILink color="primary" href="https://creativecommons.org/licenses/by/3.0/" target="_blank">Learn more</MUILink></>,
        "CC0 1.0": () => <>These models are public domain, meaning you can use them in any project (personal or commercial) with no strings attached. But if you're feeling nice, you can still credit the creator by including the text below in your project. <MUILink color="primary" href="https://creativecommons.org/publicdomain/zero/1.0/" target="_blank">Learn more</MUILink></>
    };

    const bundleLink = typeof window !== "undefined" ? window.location.href : ''; //hack to avoid ssr 

    const Attribution = {
        "CC-BY 3.0": () =><><MUILink color="primary" href={bundleLink}>{props.bundle.Name}</MUILink> by <MUILink color="primary" href={`https://poly.pizza/u/${props.bundle.Owner.Username}`}>{props.bundle.Owner.Username}</MUILink> [<MUILink color="primary" href="https://creativecommons.org/licenses/by/3.0/">CC-BY</MUILink>] via Poly Pizza</>,
        "mixed": () =><><MUILink color="primary" href={bundleLink}>{props.bundle.Name}</MUILink> by <MUILink color="primary" href={`https://poly.pizza/u/${props.bundle.Owner.Username}`}>{props.bundle.Owner.Username}</MUILink> [<MUILink color="primary" href="https://creativecommons.org/licenses/by/3.0/">CC-BY</MUILink>] via Poly Pizza</>,
        "CC0 1.0": () =><><MUILink color="primary" href={bundleLink}>{props.bundle.Name}</MUILink> by <MUILink color="primary" href={`https://poly.pizza/u/${props.bundle.Owner.Username}`}>{props.bundle.Owner.Username}</MUILink> via Poly Pizza</>,
    }


    return (
        <Dialog
            open={props.open}
            onClose={props.handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{title[props.licence]}</DialogTitle>
            <DialogContent className='overflow-hidden'>

                <DialogContentText>
                    {licenceText[props.licence]()}
                </DialogContentText>


                <div style={{ padding: '30px' }}>
                    <Typography variant="h6" className="!text-center" ref={attributionRef}>
                        {Attribution[props.licence]()}
                    </Typography>
                </div>

            </DialogContent>
            <DialogActions>
                <Button variant="contained" color="primary" onClick={() => copyElementToClipboard(attributionRef.current, props.snackbar)}>
                    Copy
                </Button>
                <Button variant="outlined" onClick={props.handleClose} color="textPrimary">
                    ok
                </Button>
            </DialogActions>
        </Dialog>
    );
}

//wat da fak
//https://stackoverflow.com/questions/34191780/javascript-copy-string-to-clipboard-as-text-html
function copyElementToClipboard(element, sb) {

    sb("Text copied!", { variant: 'success' })

    window.getSelection().removeAllRanges();
    let range = document.createRange();
    range.selectNode(typeof element === 'string' ? document.getElementById(element) : element);
    window.getSelection().addRange(range);
    document.execCommand('copy');
    window.getSelection().removeAllRanges();

    // window?.plausible("List Attributed");
}